import { debounce, DebounceSettings } from "lodash";
import { useCallback } from "react";

import { TimeSpan } from "../TimeSpan";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebouncedCallback = <T extends (...args: any) => any>(
  callback: T,
  dependencies: unknown[],
  delay: TimeSpan,
  options?: DebounceSettings,
  // eslint-disable-next-line max-params
) => {
  // FIX ME
  // const comboDeps = dependencies
  //     ? [callback, delay, ...dependencies]
  //     : [callback, delay];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(
    debounce(
      (...args) => {
        callback(...args);
      },
      delay.milliseconds,
      options,
    ),
    [...dependencies],
  );
};
